import { AxiosInstance } from 'axios'

import { withGenericErrorHandling } from '../errors'

export interface FormValidationResult {
  success: boolean
  errors: string[]
}

export interface FormValidationClient {
  validateForm: (
    validator: string,
    data: Record<string, unknown>,
  ) => Promise<FormValidationResult>
}

export const createFormValidationClient = (
  getInstance: () => Promise<AxiosInstance>,
): FormValidationClient => ({
  validateForm: (validationProfile, data) =>
    withGenericErrorHandling(async () => {
      const instance = await getInstance()
      const response = await instance.post<FormValidationResult>(
        `form/validation/${validationProfile}`,
        {
          data,
        },
      )
      return response.data
    }),
})
